import http from '@/services/http'

interface ApiConfig {
  method: string
  path: string
  fnMeta: {
    parameters: { kind: 'body' | 'query' | 'uri' | 'header' }[]
  }
}
export function fetchApi(config: ApiConfig, ...args: any) {
  const resInit: RequestInit = {
    method: config.method.toUpperCase(),
    headers: {
      'content-type': 'application/json',
    },
  }

  const query: any = {}
  const param: any = {}
  config.fnMeta.parameters.forEach((p, i) => {
    if (p.kind === 'body') resInit.body = args[i]
    else if (p.kind === 'query') Object.assign(query, args[i])
    else if (p.kind === 'uri') Object.assign(param, args[i])
    else if (p.kind === 'header') Object.assign(resInit.headers as any, args[i])
  })

  const otherArgs = args.slice(config.fnMeta.parameters.length)

  // 可以用任意前端http请求库替换（例如axios）
  if (resInit.method === 'POST') {
    return http.admin.post(makeUrl(config.path, param, query), resInit.body, ...otherArgs).then((res) => {
      if (res.code === 'SUCCESS') return cacheOriginResp(res)
      else throw res
    })
  }
  if (resInit.method === 'GET') {
    return http.admin.get(makeUrl(config.path, param, query), { params: resInit.body }).then((res) => {
      if (res.code === 'SUCCESS') return cacheOriginResp(res)
      else throw res
    })
  }
}

export const apiHost = ''

function makeUrl(url: string, param: any, query: any) {
  const fullUrl = url.replace(/:\w+/g, (w) => {
    const key = w.slice(1)
    return param[key] || w
  })
  let queryStr = Object.keys(query)
    .map((key) => `${key}=${encodeURIComponent(query[key])}`)
    .join('&')
  if (queryStr) queryStr = '?' + queryStr
  return `${apiHost}${fullUrl}${queryStr}`
}

const originRespMap = new Map()

/**
 * 返回data，并缓存原始resp
 * @param resp
 * @returns
 */
export function cacheOriginResp<T>(resp: { data: T }) {
  originRespMap.set(resp.data, resp)
  setTimeout(() => originRespMap.delete(resp.data), 1000 * 30)
  return resp.data
}

/**
 * 根据data，获取原始的resp
 * @param data
 * @returns
 */
export function getOriginResp<T>(data: T) {
  return originRespMap.get(data) as { code: string; data: T; message: string }
}
